import { useMsal } from '@azure/msal-react'
import { useLocalStorage } from '@mantine/hooks'
import { Navigate, Route, Routes } from 'react-router-dom'
import ProtectedAdminRoute from './components/auth/ProtectedAdminRoute'
import ProtectedRoutes from './components/auth/ProtectedRoutes'
import { useSessionInfo } from './contexts/SessionContext'
import AdminPage from './pages/AdminPage'
import CartPage from './pages/CartPage'
import CheckoutPage from './pages/CheckoutPage'
import AdvertisementDetailsPage from './pages/dashboard/AdvertisementDetailsPage'
import BundleDetailsPage from './pages/dashboard/BundleDetailsPage'
import AdvertisementsPage from './pages/dashboard/AdvertisementsPage'
import BillingPage from './pages/dashboard/BillingPage'
import DashboardPage from './pages/dashboard/DashboardPage'
import DesignRequestDetailsPage from './pages/dashboard/DesignRequestDetailsPage'
import DesignRequestsPage from './pages/dashboard/DesignRequestsPage'
import HostDashboardPage from './pages/dashboard/HostDashboardPage'
import MetricsPage from './pages/dashboard/MetricsPage'
import MyLocationsPage from './pages/dashboard/ManageLocationsPage'
import NotificationsPage from './pages/dashboard/NotificationsPage'
import TransactionDetailsPage from './pages/dashboard/TransactionDetailsPage'
import TransactionHistoryPage from './pages/dashboard/TransactionHistoryPage'
import { DevicePage } from './pages/DevicePage'
import { DeviceCelebrationPage } from './pages/DeviceCelebrationPage'
import EditDevicePage from './pages/EditDevicePage'
import { EditLocationPage } from './pages/EditLocationPage'
import ErrorPage from './pages/ErrorPage'
import { Home } from './pages/Home'
import HostOnboarding from './pages/HostOnboarding'
import LocationPage from './pages/LocationPage'
import PageNotFound from './pages/NotFoundPage'
import Onboarding from './pages/Onboarding'
import PaymentSuccessPage from './pages/PaymentSuccessPage'
import About from './pages/About'
import CommunityPage from './pages/CommunityPage'
import CommunityGemDetailPage from './pages/CommunityGemDetailPage'
import ConfigureAdPage from './pages/ConfigureAdPage'
import ConfigureAllLocationsAdPage from './pages/ConfigureAllLocationsAdPage'

export const Pages = () => {
  const { session } = useSessionInfo()
  const { instance } = useMsal()
  const [isHostMode] = useLocalStorage({
    key: 'isHostMode',
    defaultValue: false,
  })

  return (session != null && session.isAdvertiserOnboardingComplete) ||
    instance.getActiveAccount() == null ? (
    <Routes>
      {/* Public Routes */}
      <Route path='/' element={<Home />} />
      <Route path='/locations/:locationId' element={<LocationPage />} />
      <Route path='/paymentSuccess' element={<PaymentSuccessPage />} />
      <Route path='error' element={<ErrorPage />} />
      <Route path='*' element={<PageNotFound />} />
      <Route path='/about' element={<About />} />
      <Route path='/community' element={<CommunityPage />} />
      <Route path='/community/:id' element={<CommunityGemDetailPage />} />
      <Route path='/device-celebration' element={<DeviceCelebrationPage />} />

      {/* Admin Route */}
      <Route
        path='/admin'
        element={
          <ProtectedAdminRoute>
            <AdminPage />
          </ProtectedAdminRoute>
        }
      />
      <Route
        path='/admin/designRequests/:id'
        element={
          <ProtectedAdminRoute>
            <DesignRequestDetailsPage isAdmin />
          </ProtectedAdminRoute>
        }
      />

      {/* Protected Routes */}
      <Route element={<ProtectedRoutes />}>
        <Route path='/dashboard' element={<DashboardPage />}>
          <Route
            index
            element={
              <Navigate to={isHostMode ? 'locationAds' : 'myAds'} replace />
            }
          />
          <Route
            path='locationAds'
            element={<AdvertisementsPage isHostingView />}
          />
          <Route path='myAds' element={<AdvertisementsPage />} />
          <Route path='metrics' element={<MetricsPage />} />
          <Route
            path='myAds/:deviceAdId'
            element={<AdvertisementDetailsPage />}
          />
          <Route
            path='myAds/bundle/:advertisementId'
            element={<BundleDetailsPage />}
          />
          <Route path='designRequests' element={<DesignRequestsPage />} />
          <Route
            path='designRequests/:id'
            element={<DesignRequestDetailsPage />}
          />
          <Route path='notifications' element={<NotificationsPage />} />
          <Route path='locations' element={<MyLocationsPage />} />
          <Route path='billing' element={<BillingPage />} />
          <Route path='transactions' element={<TransactionHistoryPage />} />
          <Route
            path='transactions/:transactionId'
            element={<TransactionDetailsPage />}
          />
          <Route path='hostDashboard' element={<HostDashboardPage />} />
        </Route>
        <Route path='/locations/add' element={<EditLocationPage />} />
        <Route
          path='/locations/edit/:locationId'
          element={<EditLocationPage />}
        />
        <Route path='/cart' element={<CartPage />} />
        <Route path='/checkout' element={<CheckoutPage />} />
        <Route path='/devices/edit/:deviceId' element={<EditDevicePage />} />
        <Route path='/devices/:deviceId' element={<DevicePage />} />
        <Route path='/devices/:deviceId/configure-ad' element={<ConfigureAdPage />} />
        <Route path='/configure-ad/all-locations' element={<ConfigureAllLocationsAdPage />} />
        <Route
          path='/locations/:locationId/devices/add'
          element={<EditDevicePage />}
        ></Route>
      </Route>

      {/* Host Onboarding Route */}
      {!session?.isHostOnboardingComplete && (
        <Route path='/hostOnboarding' element={<HostOnboarding />} />
      )}
    </Routes>
  ) : (
    <Routes>
      <Route path='*' element={<Onboarding />} />
    </Routes>
  )
}
